import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject, Input, OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-scrollable-wrapper',
  standalone: true,
  imports: [],
  templateUrl: './scrollable-wrapper.component.html',
  styleUrl: './scrollable-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'd-contents'
  }
})
export class ScrollableWrapperComponent extends BaseComponent implements AfterViewInit, OnDestroy {

  @ViewChild('scrollableWrapper') scrollableWrapper: ElementRef<HTMLDivElement>;

  @Input() isGrowing = true;

  private _resizeObserver: ResizeObserver;
  private readonly _renderer = inject(Renderer2);

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.updatePadding();

      fromEvent(window, 'resize').pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(() => this.updatePadding());

      this._resizeObserver = new ResizeObserver(() => this.updatePadding());

      this._resizeObserver.observe(this.scrollableWrapper.nativeElement);
    });
  }

  private updatePadding(): void {
    const { nativeElement: element } = this.scrollableWrapper;

    element.scrollHeight > element.clientHeight
      ? this._renderer.addClass(element, 'p-r-8')
      : this._renderer.removeClass(element, 'p-r-8');
  }

  public ngOnDestroy(): void {
    this._resizeObserver?.disconnect();
  }
}
